"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_hyperlink_1 = __importDefault(require("react-native-hyperlink"));
const react_redux_1 = require("react-redux");
const config_1 = require("../../../../web/firebase/config");
const slice_1 = __importDefault(require("../../../app-reduxs/app/slice"));
const IconComment_1 = __importDefault(require("../../../assets/icons/IconComment"));
const IconReset_1 = __importDefault(require("../../../assets/icons/IconReset"));
const images_1 = require("../../../assets/images");
const components_1 = require("../../../components");
const IconLike_1 = __importDefault(require("../../../components/Icon/IconLike"));
const IconRetweet_1 = __importDefault(require("../../../components/Icon/IconRetweet"));
const IconThreeDoc_1 = __importDefault(require("../../../components/Icon/IconThreeDoc"));
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const constants_1 = require("../../../constants");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const helpler_1 = require("../../../utils/helpler");
const scale_1 = require("../../../utils/scale");
const ListImage_1 = __importDefault(require("../../HomeScreen/components/ListImage"));
const tooltips_1 = require("../../../components/tooltips");
const CONTENT_LINE_HEIGHT = (0, scale_1.moderateScale)(22.5);
const DEFAULT_LINES = 20;
const TimelineItem = (props) => {
    const { data, userId, isMyProfile } = props;
    const dispatch = (0, react_redux_1.useDispatch)();
    const [isFolded, setFolded] = (0, react_1.useState)(true);
    const [showMoreButtonVisible, setShowMoreButtonVisible] = (0, react_1.useState)(false);
    const [quoteShowMoreBtnVisible, setQuoteShowMoreBtnVisible] = (0, react_1.useState)(false);
    const [quotePost, setQuotePost] = (0, react_1.useState)();
    const [dataTweet, setDataTweet] = (0, react_1.useState)(data);
    const [visible, setVisible] = (0, react_1.useState)(true);
    const [pathTweet, setPathTweet] = (0, react_1.useState)(data?.path || 'tweets');
    const myProfile = (0, react_redux_1.useSelector)((state) => state.loginReducer.dataProfile);
    const isAnonymous = myProfile?.registration_status == 0;
    const dataListFollow = (0, react_redux_1.useSelector)((state) => state?.listFollowReducer?.listFollow);
    const dataListBlock = (0, react_redux_1.useSelector)((state) => state?.listBlockReducer?.listBlock);
    const dataListMute = (0, react_redux_1.useSelector)((state) => state?.listMuteReducer?.listMute);
    (0, react_1.useEffect)(() => {
        if (data.type == 3 && data.quoteTweetPath) {
            const path = data?.quoteTweetPath;
            let containsReplies = path?.indexOf('replies') != -1;
            let parts = '';
            let textAfterSlash = null;
            let textpath = null;
            if (containsReplies) {
                textpath = path?.slice(0, path?.lastIndexOf('replies') + 7);
                textAfterSlash = path?.slice(path?.lastIndexOf('replies') + 8);
            }
            else {
                parts = path.split('/');
                textAfterSlash = parts[1];
            }
            config_1.firebase
                .firestore()
                .collection(textpath ? textpath : 'tweets')
                .doc(textAfterSlash)
                .get()
                .then((res) => {
                setQuotePost({ ...res.data(), _id: res.id });
            })
                .catch(() => { });
        }
        else if (data?.type == 2 && data?.repostTweetPath) {
            const path = data?.repostTweetPath;
            let containsRelai = path?.indexOf('replies') != -1;
            let parts = '';
            let textAfterSlash = null;
            let textpath = null;
            if (containsRelai) {
                textpath = path?.slice(0, path?.lastIndexOf('replies') + 7);
                textAfterSlash = path?.slice(path?.lastIndexOf('replies') + 8);
            }
            else {
                parts = path?.split('/');
                textAfterSlash = parts[1];
            }
            setPathTweet(textpath ? `${textpath}/${textAfterSlash}` : `tweets/${textAfterSlash}`);
            //setIdPost(textAfterSlash)
            config_1.firebase
                .firestore()
                .collection(textpath ? textpath : 'tweets')
                .doc(textAfterSlash)
                .onSnapshot((snapshot) => {
                let dataRetweet = snapshot.data();
                dataRetweet._id = snapshot.id;
                dataRetweet.tweetId = snapshot.id;
                setDataTweet(dataRetweet);
            });
        }
        else {
            setDataTweet(data);
        }
    }, [data]);
    const checkDataReTweet = () => {
        let isFollow = dataListFollow.some((item) => item == dataTweet?.userId);
        let isBlock = dataListBlock.some((item) => item == dataTweet?.userId);
        let isMute = dataListMute.some((item) => item == dataTweet?.userId);
        if (data?.type == 2 && dataTweet?.isDeleted == 1) {
            return '投稿者によって削除された投稿です';
        }
        else if (dataTweet?.publicationRange == 1 &&
            !isFollow &&
            data?.type == 2 &&
            dataTweet?.userId != myProfile?.user_id) {
            return `フォロワー限定の投稿です。\nフォローして投稿を見てみましょう。`;
        }
        else if (data?.type == 2 && isBlock) {
            return `あなたがブロックしたユーザーの投稿です`;
        }
        else if (data?.type == 2 && isMute) {
            return `あなたがミュートしたユーザーの投稿です`;
        }
        return '';
    };
    const checkDataQuoteTweet = () => {
        let isFollow = dataListFollow.some((item) => item == quotePost?.userId);
        let isBlock = dataListBlock.some((item) => item == quotePost?.userId);
        let isMute = dataListMute.some((item) => item == quotePost?.userId);
        if (quotePost?.isDeleted == 1) {
            return '投稿者によって削除された投稿です';
        }
        else if (quotePost?.publicationRange == 1 &&
            !isFollow &&
            quotePost?.userId != myProfile?.user_id) {
            return `フォロワー限定の投稿です。\nフォローして投稿を見てみましょう。`;
        }
        else if (isBlock) {
            return `あなたがブロックしたユーザーの投稿です`;
        }
        else if (isMute) {
            return `ミュートされた投稿者によって作成した投稿です`;
        }
        return "";
    };
    const userNoPermission = (0, react_1.useMemo)(checkDataReTweet, [data, dataTweet, dataListFollow, dataListBlock, dataListMute]);
    const userNoPermissionQuote = (0, react_1.useMemo)(checkDataQuoteTweet, [data, quotePost, dataListFollow, dataListBlock, dataListMute]);
    const handleShowMore = () => {
        setShowMoreButtonVisible(false);
        setFolded(false);
    };
    const onLayout = (event) => {
        const contentLine = ~~(event.nativeEvent.layout.height / CONTENT_LINE_HEIGHT);
        if (contentLine > DEFAULT_LINES) {
            setShowMoreButtonVisible(true);
        }
    };
    const onQuoteLayout = (event) => {
        const contentLine = ~~(event.nativeEvent.layout.height / CONTENT_LINE_HEIGHT);
        if (contentLine > DEFAULT_LINES) {
            setQuoteShowMoreBtnVisible(true);
        }
    };
    const navigateToUserProfile = () => {
        if (userId != dataTweet.userId) {
            (0, rootNavigation_1.push)(Routes_1.default.USER_PROFILE, {
                userHandle: dataTweet.userHandle,
            });
        }
    };
    const navigateToArticleDetail = () => {
        (0, rootNavigation_1.navigate)(Routes_1.default.HOME_ARTICLE_DETAIL, { postId: (0, helpler_1.urlPost)(pathTweet) });
    };
    if (!visible)
        return null;
    return (react_1.default.createElement(react_native_1.View, { style: styles.container },
        data?.type == 2 && (react_1.default.createElement(react_native_1.View, { style: {
                flexDirection: 'row',
                alignItems: 'center',
                marginBottom: (0, scale_1.scale)(8),
            } },
            react_1.default.createElement(IconReset_1.default, { color: "#545454" }),
            react_1.default.createElement(CustomText_1.default, { numberOfLines: 1, style: styles.textReTweet, weight: "300" }, isMyProfile
                ? 'あなたが引用しました'
                : `${data?.nickname || constants_1.DEFAULT_NAME}さんが引用しました`))),
        react_1.default.createElement(react_native_1.View, { style: { width: '100%', flexDirection: 'row' } },
            react_1.default.createElement(react_native_1.Pressable, { onPress: navigateToUserProfile },
                react_1.default.createElement(react_native_1.Image, { source: dataTweet?.thumbnailUrl
                        ? { uri: dataTweet?.thumbnailUrl }
                        : images_1.images.AvatarDefaul, style: styles.avatar })),
            react_1.default.createElement(react_native_1.Pressable, { style: styles.body, onPress: navigateToArticleDetail },
                react_1.default.createElement(react_native_1.View, { style: styles.row },
                    react_1.default.createElement(react_native_1.View, { style: styles.userInfo },
                        react_1.default.createElement(react_native_1.View, { style: styles.row },
                            react_1.default.createElement(CustomText_1.default, { numberOfLines: 1, style: styles.textName, weight: "600", onPress: navigateToUserProfile }, dataTweet?.nickname || constants_1.DEFAULT_NAME),
                            react_1.default.createElement(react_native_1.View, { style: { marginLeft: (0, scale_1.scale)(12) } },
                                react_1.default.createElement(tooltips_1.DateTimeTooltip, { title: (0, moment_1.default)(dataTweet?.createdAt).format('YYYY/MM/DD HH:mm') }, `${(0, helpler_1.secondToDateFormat)(dataTweet?.createdAt)} `))),
                        react_1.default.createElement(CustomText_1.default, { style: styles.textTagName, weight: "300" },
                            "@",
                            dataTweet?.userHandle)),
                    react_1.default.createElement(IconThreeDoc_1.default, { data: dataTweet, uri: `${window.location.origin}/post?postId=${(0, helpler_1.urlPost)(pathTweet)}`, displayTweet: (_data) => {
                            setVisible(false);
                        }, firestorePath: 'tweets' })),
                !userNoPermission && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(components_1.PublicRangeView, { publicRange: dataTweet?.publicationRange, disabled: true }),
                    react_1.default.createElement(react_native_1.View, { style: {
                            marginTop: (0, scale_1.scale)(8),
                            width: '100%',
                            position: 'relative',
                            overflow: 'hidden',
                        } },
                        react_1.default.createElement(react_native_hyperlink_1.default, { onPress: (url) => react_native_1.Linking.openURL(url), linkStyle: {
                                color: '#06c',
                                textDecorationLine: 'underline',
                            } },
                            react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles.timelineContent, numberOfLines: isFolded ? DEFAULT_LINES : undefined }, dataTweet?.content
                                ?.split(helpler_1.hashtagRegex)
                                .map((string, index) => {
                                if (string.match(helpler_1.hashtagRegex)) {
                                    return (react_1.default.createElement(components_1.HashtagText, { text: string.replace(/(#|＃)/g, ''), key: index, style: styles.timelineContent, onPress: () => {
                                            (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                                                screen: Routes_1.default.HASHTAG_DETAIL,
                                                params: {
                                                    hashtag: string.replace(/(#|＃)/g, ''),
                                                    typeScreen: 0,
                                                    typeHashTag: 3,
                                                },
                                            });
                                        } }));
                                }
                                return react_1.default.createElement(react_native_1.Text, { key: index }, string);
                            }))),
                        react_1.default.createElement(react_native_1.View, { style: { position: 'absolute', zIndex: 0, opacity: 0 } },
                            react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles.timelineContent, onLayout: onLayout }, dataTweet?.content
                                ?.split(helpler_1.hashtagRegex)
                                .map((string, index) => {
                                if (string.match(helpler_1.hashtagRegex)) {
                                    return (react_1.default.createElement(components_1.HashtagText, { text: string.replace(/(#|＃)/g, ''), key: index, style: styles.timelineContent, onPress: () => {
                                            (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                                                screen: Routes_1.default.HASHTAG_DETAIL,
                                                params: {
                                                    hashtag: string.replace(/(#|＃)/g, ''),
                                                    typeScreen: 0,
                                                    typeHashTag: 3,
                                                },
                                            });
                                        } }));
                                }
                                return react_1.default.createElement(react_native_1.Text, { key: index }, string);
                            })))),
                    showMoreButtonVisible && (react_1.default.createElement(CustomText_1.default, { onPress: handleShowMore, weight: "300", style: {
                            marginTop: (0, scale_1.scale)(4),
                            fontSize: (0, scale_1.moderateScale)(12),
                            lineHeight: (0, scale_1.moderateScale)(18),
                            color: '#007AFF',
                        } }, "\u7D9A\u304D\u3092\u898B\u308B")),
                    react_1.default.createElement(ListImage_1.default, { data: dataTweet?.images, type: "post" }),
                    !!quotePost && (react_1.default.createElement(react_native_1.View, { style: styles.quotePost },
                        react_1.default.createElement(react_native_1.View, { style: [styles.row, { zIndex: 1 }] },
                            react_1.default.createElement(react_native_1.Image, { source: quotePost.thumbnailUrl
                                    ? { uri: quotePost.thumbnailUrl }
                                    : images_1.images.AvatarDefaul, style: styles.quoteAvatar }),
                            react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles.quoteNickname, numberOfLines: 1 }, quotePost.nickname || constants_1.DEFAULT_NAME),
                            react_1.default.createElement(tooltips_1.DateTimeTooltip, { title: (0, moment_1.default)(quotePost.createdAt).format('YYYY/MM/DD HH:mm') }, `${(0, helpler_1.secondToDateFormat)(quotePost?.createdAt)} `)),
                        !!userNoPermissionQuote ? (react_1.default.createElement(react_native_1.View, { style: {
                                width: '100%',
                                borderWidth: (0, scale_1.scale)(1),
                                borderColor: '#DDDDDD',
                                borderRadius: (0, scale_1.scale)(3),
                                backgroundColor: '#EEEEEE',
                                marginTop: (0, scale_1.scale)(12),
                                padding: (0, scale_1.scale)(12),
                            } },
                            react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                                    fontSize: (0, scale_1.moderateScale)(14),
                                    lineHeight: (0, scale_1.moderateScale)(21),
                                    color: '#292A33',
                                } }, userNoPermissionQuote))) : (react_1.default.createElement(react_native_1.View, { style: { position: 'relative' } },
                            react_1.default.createElement(react_native_hyperlink_1.default, { onPress: (url) => react_native_1.Linking.openURL(url), linkStyle: {
                                    color: '#06c',
                                    textDecorationLine: 'underline',
                                }, style: { zIndex: 1 } },
                                react_1.default.createElement(CustomText_1.default, { numberOfLines: DEFAULT_LINES, style: styles.quoteContent },
                                    react_1.default.createElement(components_1.RenderTextContent, { text: quotePost.content }))),
                            react_1.default.createElement(react_native_1.View, { style: {
                                    position: 'absolute',
                                    zIndex: 0,
                                    opacity: 0,
                                } },
                                react_1.default.createElement(CustomText_1.default, { style: styles.quoteContent, onLayout: onQuoteLayout },
                                    react_1.default.createElement(components_1.RenderTextContent, { text: quotePost.content }))),
                            quoteShowMoreBtnVisible && (react_1.default.createElement(CustomText_1.default, { style: styles.quoteButton, onPress: () => {
                                    (0, rootNavigation_1.navigate)(Routes_1.default.HOME_ARTICLE_DETAIL, {
                                        postId: (0, helpler_1.urlPost)(quotePost.path),
                                    });
                                } }, "\u7D9A\u304D\u3092\u898B\u308B")))))),
                    react_1.default.createElement(react_native_1.View, { style: {
                            flexDirection: 'row',
                            alignItems: 'center',
                            marginTop: (0, scale_1.scale)(12),
                        } },
                        react_1.default.createElement(react_native_1.TouchableOpacity, { style: { flexDirection: 'row', alignItems: 'center' }, onPress: () => {
                                if (isAnonymous) {
                                    return dispatch(slice_1.default.actions.showRequestLoginModal());
                                }
                                (0, rootNavigation_1.navigate)(Routes_1.default.REP_COMMENT, {
                                    data: (0, helpler_1.urlPost)(pathTweet),
                                    type: 'POST',
                                    // firestorePath: 'tweets',
                                });
                            } },
                            react_1.default.createElement(IconComment_1.default, { color: '#545454' }),
                            react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                                    fontSize: (0, scale_1.moderateScale)(12),
                                    lineHeight: (0, scale_1.moderateScale)(18),
                                    color: '#545454',
                                    marginLeft: (0, scale_1.scale)(8),
                                    marginRight: (0, scale_1.scale)(24),
                                } }, dataTweet?.numOfReplies || 0)),
                        react_1.default.createElement(IconRetweet_1.default, { idPost: data?._id, dataTweet: dataTweet, data: data, displayTweet: (_data) => { } }),
                        react_1.default.createElement(IconLike_1.default, { numberLikes: +dataTweet.likes, idPost: dataTweet._id })))))),
        !!userNoPermission && (react_1.default.createElement(react_native_1.View, { style: {
                width: '100%',
                borderWidth: (0, scale_1.scale)(1),
                borderColor: '#DDDDDD',
                borderRadius: (0, scale_1.scale)(3),
                backgroundColor: '#EEEEEE',
                marginTop: (0, scale_1.scale)(12),
                paddingHorizontal: (0, scale_1.scale)(24),
                paddingVertical: (0, scale_1.scale)(12),
            } },
            react_1.default.createElement(CustomText_1.default, { style: {
                    fontSize: (0, scale_1.moderateScale)(14),
                    lineHeight: (0, scale_1.moderateScale)(21),
                    color: '#292A33',
                } }, userNoPermission)))));
};
const styles = react_native_1.StyleSheet.create({
    row: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    container: {
        paddingVertical: (0, scale_1.scale)(12),
        width: '100%',
        paddingHorizontal: (0, scale_1.scale)(16),
        paddingTop: (0, scale_1.scale)(12),
        borderBottomWidth: 1,
        borderColor: '#DDDDDD',
    },
    textReTweet: {
        marginLeft: (0, scale_1.scale)(8),
        color: '#888888',
        fontSize: (0, scale_1.moderateScale)(12),
        lineHeight: (0, scale_1.moderateScale)(18),
    },
    textName: {
        flexShrink: 1,
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: '#292A33',
    },
    textTime: {
        fontSize: (0, scale_1.moderateScale)(10),
        lineHeight: (0, scale_1.moderateScale)(17),
        color: '#888888',
        // marginLeft: scale(12),
    },
    textTagName: {
        fontSize: (0, scale_1.moderateScale)(10),
        lineHeight: (0, scale_1.moderateScale)(17),
        color: '#888888',
    },
    textTimeNow: {
        position: 'absolute',
        paddingHorizontal: (0, scale_1.scale)(4),
        paddingVertical: (0, scale_1.scale)(2),
        top: (0, scale_1.moderateScale)(17) + (0, scale_1.scale)(4),
        left: -(0, scale_1.scale)(20),
        borderRadius: (0, scale_1.scale)(2),
        backgroundColor: '#000000B2',
    },
    textTimeNowLabel: {
        color: '#FEFEFE',
        fontSize: (0, scale_1.moderateScale)(9),
        lineHeight: (0, scale_1.moderateScale)(13.5),
    },
    viewQuoteTweet: {
        width: (0, scale_1.scale)(295),
        borderWidth: 1,
        borderColor: '#DDDDDD',
        borderRadius: (0, scale_1.scale)(5),
        paddingHorizontal: (0, scale_1.scale)(12),
        paddingVertical: (0, scale_1.scale)(12),
        marginTop: (0, scale_1.scale)(8),
    },
    avatar: {
        height: (0, scale_1.scale)(40),
        width: (0, scale_1.scale)(40),
        borderRadius: 999,
    },
    body: {
        flex: 1,
        marginLeft: (0, scale_1.scale)(12),
    },
    userInfo: {
        flex: 1,
        height: (0, scale_1.scale)(40),
        marginRight: (0, scale_1.scale)(24),
        justifyContent: 'space-between',
    },
    timelineContent: {
        fontSize: (0, scale_1.moderateScale)(15),
        lineHeight: CONTENT_LINE_HEIGHT,
        color: '#292A33',
        // marginTop: scale(8),
    },
    quotePost: {
        marginTop: (0, scale_1.scale)(8),
        borderRadius: (0, scale_1.scale)(5),
        borderWidth: (0, scale_1.scale)(1),
        borderColor: '#DDDDDD',
        padding: (0, scale_1.scale)(12),
        backgroundColor: '#FEFEFE'
    },
    quoteAvatar: {
        width: (0, scale_1.scale)(20),
        height: (0, scale_1.scale)(20),
        borderRadius: 99,
    },
    quoteNickname: {
        flex: 1,
        marginHorizontal: (0, scale_1.scale)(8),
        fontSize: (0, scale_1.moderateScale)(12),
        lineHeight: (0, scale_1.moderateScale)(18),
        color: '#292A33',
    },
    quoteTime: {
        fontSize: (0, scale_1.moderateScale)(10),
        lineHeight: (0, scale_1.moderateScale)(17),
        color: '#888888',
    },
    quoteContent: {
        marginTop: (0, scale_1.scale)(12),
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: CONTENT_LINE_HEIGHT,
        color: '#292A33',
    },
    quoteButton: {
        marginTop: (0, scale_1.scale)(4),
        fontSize: (0, scale_1.moderateScale)(12),
        lineHeight: (0, scale_1.moderateScale)(18),
        color: '#007AFF',
    },
});
exports.default = TimelineItem;
